import type { RoleAssignmentResponse } from '../../../services/api';

/** role_id → Set of selected clinic_ids (clinic scope) */
export type ClinicSelectionMap = Map<string, Set<string>>;

/** Build clinic-scoped role selection, omitting hidden Kinnser clinic IDs. */
export function buildInitialClinicSelectionFromAssignments(
  assignments: RoleAssignmentResponse[],
  hiddenClinicIds?: ReadonlySet<string>
): ClinicSelectionMap {
  const selection: ClinicSelectionMap = new Map();

  for (const assignment of assignments) {
    if (assignment.clinic_id == null) continue;
    if (hiddenClinicIds?.has(assignment.clinic_id)) continue;

    const existing = selection.get(assignment.role_id) ?? new Set<string>();
    existing.add(assignment.clinic_id);
    selection.set(assignment.role_id, existing);
  }

  return selection;
}
